import { CSSProperties, FC, PropsWithChildren } from "react"
import style from "./SbtH3.module.css"

type Props = PropsWithChildren & {
	styles?: CSSProperties
}

/* SBT - H3 28pt regular */
export const SbtH3: FC<Props> = ({ children, styles }) => {
	return (
		<h3 style={styles} className={style.sbtH3}>
			{children}
		</h3>
	)
}
